import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ru from './locales/ru.json';
import es from './locales/es.json';

export const SUPPORTED_LOCALES = ['en', 'ru', 'es'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const LOCALE_PREFIXES: Record<SupportedLocale, string> = {
  en: '',
  ru: '/ru',
  es: '/es',
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
      es: { translation: es },
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
